import React from "react";
import { RefreshCw } from "lucide-react";

/**
 * Round spinner that slides down from under the top bar while pulling.
 * Driven by usePullToRefresh's { pull, refreshing, threshold }.
 */
export default function PullIndicator({ pull, refreshing, threshold = 72, topOffset = 56 }) {
  if (pull <= 0 && !refreshing) return null;
  const progress = Math.min(1, pull / threshold);
  return (
    <div
      aria-hidden
      className="pointer-events-none fixed inset-x-0 z-20 flex justify-center"
      style={{ top: `calc(env(safe-area-inset-top, 0px) + ${topOffset}px)` }}
    >
      <div
        className="grid h-10 w-10 place-items-center rounded-full bg-white shadow-[0_4px_16px_rgba(0,0,0,0.16)] ring-1 ring-stone-200"
        style={{
          transform: `translateY(${Math.max(0, pull - 28)}px) scale(${0.6 + 0.4 * progress})`,
          opacity: 0.3 + 0.7 * progress,
        }}
      >
        <RefreshCw
          className={`h-5 w-5 text-[#E05236] ${refreshing ? "animate-spin" : ""}`}
          strokeWidth={2.25}
          style={refreshing ? undefined : { transform: `rotate(${progress * 270}deg)` }}
        />
      </div>
    </div>
  );
}
